const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  user_type: state => state.user.userType,
  name: state => state.user.name,
  realName: state => state.user.realName, 
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js